module.exports = __webpack_public_path__ + "static/media/8.b90db7f3.jpg";